import * as format from '../data/format';
import { MONTHS, MONTHS_SHORT, APOSTROPHE, NBSP } from '../data/constants';
import { YEAR_MILLISECONDS } from './axes-common';
import { addZeroes } from '../data/zero';
import assign from 'lodash.assign';

let isPrint;

export default function axesPreRender(data, options, styles) {
  data = writeCommonOptions(data, options);
  switch (options.type) {
    case 'pie':
      return data;
    case 'bar':
      data = writeHorizontalOptions(data, options, styles);
      break;
    default:
      data = writeVerticalOptions(data, options, styles);
      break;
  }
  if (options.product !== 'financialnews') {
    data.xAxis.gridLineColor = data.yAxis.gridLineColor = options.print ?
    '#bfbfbf' : '#e6e6e6';
  } else {
    data.xAxis.gridLineColor = data.yAxis.gridLineColor = options.print ? '#000000' : '#e6e6e6';
  }

  data.tooltip.enabled = options.showTooltips && !options.print ? true : false;

  data = writeMinMax(data, options);
  if (!options.mobileXAxisIntervalSameAsDesktop && options.mobileXAxisInterval !== 'auto' && options.mobileXAxisInterval !== undefined) {
    tickIntervalCalc(options, data, true)
  }
  if (options.xAxisInterval !== 'auto' && options.xAxisInterval !== undefined && (options.width >= 620 || options.mobileXAxisIntervalSameAsDesktop)) {
    tickIntervalCalc(options, data, false)
  }

  if (!options.yAxisMobileEnabled && (options.yAxisMobileInterval !== '') && options.yAxisMobileInterval !== undefined && options.width < 620) {
    setTickIntervalForYAxis(options, data, true)
  }

  if ((options.yAxisInterval !== '') && options.yAxisInterval !== undefined && (options.width >= 620 || options.yAxisMobileEnabled)) {
    setTickIntervalForYAxis(options, data, false)
  }

  return data;
}

function setTickIntervalForYAxis(options, data, isMobile) {
  const typeOfInterval = isMobile ? 'yAxisMobileInterval' : 'yAxisInterval';
  const interval = options[typeOfInterval]
  if (interval !== '') {
    data.yAxis.tickInterval = Number(interval);
  }
}

function tickIntervalCalc(options, data, isMobile) {
  const typeOfInterval = isMobile ? 'mobileXAxisInterval' : 'xAxisInterval';
  let interval = options[typeOfInterval].split(' ')[0];
  let unit = options[typeOfInterval].split(' ')[1];
  if (unit === 'years' || unit === 'year') {
    data.xAxis.tickInterval = 24 * 3600 * 1000 * 365 * parseInt(interval);
  }
  if (unit === 'months' || unit === 'month') {
    data.xAxis.tickInterval = 24 * 3600 * 1000 * 30 * parseInt(interval);
  }
  if (unit === 'day') {
    data.xAxis.tickInterval = 24 * 3600 * 1000;
  }
  if (unit === 'week') {
    data.xAxis.tickInterval = 24 * 3600 * 1000 * 7;
  }
}



// Options common to all charts with axes.
function writeCommonOptions(data, options) {
  let offsetVal = 0;
  let oppositeVal = false;
  let horizontalGridLineStyle = 'solid';
  if (options.type === 'line' || options.type === 'area') {
    data.plotOptions.series.connectNulls = options.connectEmptyDataPoints;
  }
  if (__MARKETWATCH__) {
    if (options.product === "marketwatch" && options.type === 'line') {
      offsetVal = 4;
      oppositeVal = true;
    }
    if (options.product === 'marketwatch' && options.type === 'column') {
      horizontalGridLineStyle = 'dash'
      oppositeVal = true;
      offsetVal = 8;
    }
  }
  if (__FINANCIALNEWS__) {
    if (options.product === 'financialnews' && (options.type === 'line' || options.type === 'column')) {
      oppositeVal = true;
      offsetVal = 4;
    }
  }

  const endOnTick = options.axes.maxYAxisValue ? false : true;
  const startOnTick = options.axes.minYAxisValue ? false : true;

  data.xAxis = {
    title: { text: '' },
    tickColor: '#000000'
  };
  data.yAxis = {
    title: { text: '' },
    tickColor: '#000000',
    offset: offsetVal,
    opposite: oppositeVal,
    gridLineDashStyle: horizontalGridLineStyle,
    endOnTick: endOnTick,
    startOnTick: startOnTick
  };

  if(__WSJ__){
    if(options.product === 'wsj'){
      data.xAxis.tickColor = options.styles.tick.color;
    }
  }
  // data.yAxis.opposite = true;
  // if (options.stacking === 'normal') {
    // data.yAxis.max = 100;
  // }
  return data;
}


// Writes chart options for bar charts (i.e., horizontal bars).
function writeHorizontalOptions(data, options, styles) {
  if (Array.isArray(options.categories)) {
    data.xAxis.categories = getCategoryLabels(options.categories[0]);
  }
  data.xAxis.tickLength = 0;
  data.xAxis.offset = -2;
  data.xAxis.lineWidth = 0;
  data.yAxis.gridLineWidth = 1;

  if (__WSJ__) {
    if (options.size === 'print-wsj') {
      data.yAxis.gridLineWidth = 0.5;
    }
  }

  const lineHeight = styles.BOLD_STYLE.fontSize;
  data.xAxis.labels = {
    style: assign({}, styles.BOLD_STYLE, {
      whiteSpace: 'wrap', textOverflow: 'visible', lineHeight
    }),
    // step: 1,
    x: -7,
    y: options.print ? 3 : undefined,
    // format: '{value}',
  };

  if (options.axes.shown) {
    data.yAxis.reversedStacks = false;
    data.yAxis.opposite = true;
    data.yAxis.reversed = !!options.axes.reversed;
    data.yAxis.labels = {
      y: -5,
      style: assign({}, styles.NORMAL_STYLE,
        { whiteSpace: 'nowrap', textOverflow: 'visible`' }),
      autoRotation: false,
      formatter: function () {

        const special = (options.axes.reversed && this.isLast) ||
          (!options.axes.reversed && this.isFirst);
        return formatterBarYAxisLabel(options.axes.units, this.value, special);
      }
    };
  }

  if (__WSJ__) {
    if (options.product === 'wsj') {
      data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
        fontSize: options.styles.axes.label.bar.x.fontSize,
        fontWeight: options.styles.axes.label.bar.x.fontWeight,
        lineHeight: options.styles.axes.label.bar.x.lineHeight
      });

      data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
        fontSize: options.styles.axes.label.bar.y.fontSize,
        fontWeight: options.styles.axes.label.bar.y.fontWeight,
        lineHeight: options.styles.axes.label.bar.y.lineHeight
      });

    }
  }

  return data;
}

function formatterBarYAxisLabel(units, value, special) {
  value = format.decimals(value, units);
  value = format.commas(value, units);
  const prefix = units.prefix || '';
  const suffix = units.suffix || '';
  if (prefix && value.charAt(0) === '-') {
    // If value is negative, put the negative sign *before* the prefix.
    value = `-${prefix}${value.substr(1)}`;
  } else {
    value = `${prefix}${value}`;
  }
  if (special && suffix) {
    value += suffix;
  }
  return value;
}


// Writes chart options for column charts (i.e, vertical bars) and charts for
// which the axes are the same as for column charts (i.e., line charts).
function writeVerticalOptions(data, options, styles) {
  const Q = options.quarterlyResults && options.series[0].data.length <= 44;
  isPrint = options.print;
  let defaultXGridWidth = 0;
  if (__MARKETWATCH__) {
    if (options.type === 'line' && options.product === 'marketwatch') {
      data.xAxis.tickColor = '#fffff';
      defaultXGridWidth = 1;
    }
    if (options.type === 'column' && options.product === 'marketwatch') {
      data.xAxis.tickColor = '#fffff';
    }
  }
  if (__FINANCIALNEWS__) {
    if (options.product === 'financialnews' && (options.type === 'line' || options.type === 'column')) {
      data.xAxis.tickColor = '#fffff';
    }
  }

  data.xAxis.tickWidth = 1;
  data.xAxis.lineWidth = 0;
  data.xAxis.gridLineWidth = defaultXGridWidth;
  data.xAxis.minorGridLineWidth = defaultXGridWidth;
  data.yAxis.gridLineWidth = 1;
  data.yAxis.tickPixelInterval = parseFloat(styles.NORMAL_STYLE.lineHeight) * 3;
  data.yAxis.reversed = !!options.axes.reversed;
  if (__WSJ__) {
    if (options.size === 'print-wsj') {
      data.xAxis.tickWidth = 0.5;
      data.yAxis.gridLineWidth = 0.5;
    }
  }
  let alignYAxis = 'right';
  let yAxisXVal = -10;
  let yAxisYVal = -5;
  if (__MARKETWATCH__) {
    if ((options.product === 'marketwatch' || options.product === 'financialnews') && (options.type === 'line' || options.type === 'column')) {
      alignYAxis = 'left';
      yAxisXVal = 0;
      yAxisYVal = -2.5;
    }
  }
  if (__FINANCIALNEWS__) {
    if (options.product === 'financialnews') {
      if (options.print === true && options.sizes['print-fn'].columns <= 2) {
        styles.LIGHT_STYLE.fontSize = 7.75;
      }
    }
  }
  if (options.print === true && options.product === 'financialnews') {
    styles.LIGHT_STYLE.color = '#000000';
  }

  data.yAxis.labels = {
    style: isPrint ? styles.LIGHT_STYLE : styles.NORMAL_STYLE,
    autoRotation: false,
    align: alignYAxis,
    x: yAxisXVal,
    y: calculateYAxesLabelY(options, yAxisYVal),
    formatter: function () {
      const tp = this.axis.tickPositions;
      const decimalsDelta = Math.abs(tp[0] - tp[1]);
      let decimalPlaces = Number.isInteger(decimalsDelta) ? 0 : roundPlaces(decimalsDelta);
      // special = should have prefix and/or suffix:
      const special = (options.axes.reversed && this.isFirst) ||
        (!options.axes.reversed && this.isLast);
      return formatterYAxisLabel(options.axes.units, this.value, decimalPlaces, special);
    }
  };

  options.axes.tickStyle = options.axes.tickStyle || 'center';
  data.xAxis.labels = {
    style: isPrint ? styles.LIGHT_STYLE : styles.NORMAL_STYLE,
    autoRotation: false,
    maxStaggerLines: 1,
  };
  data.xAxis.labels.style.textOverflow = 'visible';
  if (!options.allowCategoriesLinebreak) {
    data.xAxis.labels.style.whiteSpace = 'nowrap';
  }
  data.xAxis.labels.align = 'center';
  data.xAxis.labels.y = styles.FONT_SIZE + 7;
  data.xAxis.tickLength = styles.MEDIUM_TICK_LENGTH;

  if (__WSJ__) {
    if (options.size === 'print-wsj') {
      data.xAxis.labels.y -= 4;
    }
  }

  if (Array.isArray(options.categories) && (Q || !options.categoriesAreDates)) {
    data.xAxis.type = 'category';
    data.xAxis.categories = getCategoryLabels(options.categories[0]);
    data.xAxis.tickmarkPlacement = 'on';
    if (Q) {
      data.xAxis.labels.formatter = formatterQuarterlyResults(options);
    }
  }
  if (options.categoriesAreDates && !Q) {
    data.xAxis.labels.style.whiteSpace = 'nowrap';

    if (options.fiscalYears) {
      data.xAxis.tickInterval = YEAR_MILLISECONDS;
    } else {
      if (!options.irregularDates) data.xAxis.tickInterval = getDatetimeTickInterval(data, options);

      const firstDate = new Date(options.originalCategories[0]);
      const lastDate = new Date(options.originalCategories[options.originalCategories.length - 1]);
      const diff = Math.abs((firstDate.getTime() - lastDate.getTime()) / (24 * 3600 * 1000));
      let hasMoreThanTwoDays = diff > 2; 
      
      if (options.irregularDates && (hasMoreThanTwoDays)) {
        data.xAxis.minTickInterval = 24 * 3600 * 1000;
      }
    }
    if (data.xAxis.tickInterval) {
      data.xAxis.tickInterval = Math.round(data.xAxis.tickInterval);
    }

    data.xAxis.labels.formatter = function () {
      return formatterDate(this, options, data.xAxis.tickInterval);
    };
    data.xAxis.type = 'datetime';
  }

  if(__WSJ__){
    if(options.product === 'wsj') {
      const isPrintColor = options.print ? 'rgb(0, 0, 0)' : options.styles.axes.label.color;
      data.yAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
        fontSize:  options.styles.axes.label.fontSize,
        color: isPrintColor,
        fill: isPrintColor
      });

      data.xAxis.labels.style = Object.assign({}, data.xAxis.labels.style, {
        fontSize:  options.styles.axes.label.fontSize,
        color: isPrintColor,
        fill: isPrintColor
      });

      if(options.type === 'column' && !options.categoriesAreDates){
        data.xAxis.labels.style = Object.assign({}, data.yAxis.labels.style, {
          fontSize: options.styles.axes.label.seriesAreNotDates.fontSize,
          fontWeight: options.styles.axes.label.seriesAreNotDates.fontWeight,
          lineHeight: options.styles.axes.label.seriesAreNotDates.lineHeight
        });
      }
    }
  }

  return data;
}

function calculateYAxesLabelY(options, initialValue){
  if (__WSJ__) {
    if (options.product === 'wsj') {
      if(options.size === 'print-wsj'){
        if(options.type === 'line') {
          return -2.5;
        }

        if(options.type === 'column') {
          return -1.5;
        }
      }
      // non print
      return -2;
    }
  }

  return initialValue;
}

// Returns correct spacing between ticks on x-axis depending.
function getDatetimeTickInterval(context, options) {
  if (options.datesAll) {
    let currYear;
    let yearsTraversed = 0;
    let yearRepeated = false;

    let currMonth;
    let monthsTraversed = 0;
    let monthRepeated = false;

    let currDate;
    let datesTraversed = 0;
    let dateRepeated = false;

    if (options.datesAll.year && !options.datesAll.month) {
      let isYears = true;
      for (let i = 0; isYears && i < options.dates.length; i++) {
        if (currYear === undefined || options.dates[i].year !== currYear) {
          currYear = options.dates[i].year;
        } else if (options.dates[i].year === currYear) {
          isYears = false;
        }
      }
      return YEAR_MILLISECONDS;
    }

    for (let i = 0; i < options.dates.length; i++) {
      // If data passes through >= 3 years but data is spaced less than a year
      // apart, ensure that ticks are spaced by years.
      if (options.datesAll.year && options.datesAll.month) {
        if (currYear === undefined || options.dates[i].year !== currYear) {
          currYear = options.dates[i].year;
          yearsTraversed += 1;
        } else if (!yearRepeated && options.dates[i].year === currYear) {
          yearRepeated = true;
        }
        if (yearRepeated && yearsTraversed >= 3) {
          return YEAR_MILLISECONDS;
        }
      }
    }

    for (let i = 0; i < options.dates.length; i++) {
      // If data passes through >= 3 months but data is spaced less than a
      // month apart, ensure that ticks are spaced by months.
      if (options.datesAll.month && options.datesAll.date) {
        if (currMonth === undefined || options.dates[i].month !== currMonth) {
          currMonth = options.dates[i].month;
          monthsTraversed += 1;
        } else if (!monthRepeated && options.dates[i].month === currMonth) {
          monthRepeated = true;
        }
        if (monthRepeated && monthsTraversed >= 3) {
          return 1000 * 60 * 60 * 24 * 30;
        }
      }
    }

    for (let i = 0; i < options.dates.length; i++) {
      // If data passes through >= 3 dates but data is spaced less than a day
      // apart, ensure that ticks are spaced by days.
      if (options.datesAll.date) {
        if (currDate === undefined || options.dates[i].date !== currDate) {
          currDate = options.dates[i].date;
          datesTraversed += 1;
        } else if (!dateRepeated && options.dates[i].date === currDate) {
          dateRepeated = true;
        }
        if (dateRepeated && datesTraversed >= 3) {
          return 1000 * 60 * 60 * 24;
        }
      }
    }

    if (options.datesAll.hour && !options.datesAll.year &&
        !options.datesAll.month) {
      let fd = options.dates[0];
      let ld = options.dates[options.dates.length - 1];
      let d1 = new Date();
      let d2 = new Date();
      var hour = 1000 * 60 * 60;
      d1.setUTCHours(fd.hour);
      d1.setUTCMinutes(fd.minute);
      d2.setUTCHours(ld.hour);
      d2.setUTCMinutes(ld.minute);
      if (d2.valueOf() - d1.valueOf() > hour) {
        return hour;
      }
    }
  }
  return null;
}



// A Highcharts `formatter` function to formate x-axis dates.
function formatterDate(context, options, interval) {
  // INDEX = (INDEX >= options.series[0].data.length) ? 0 : INDEX;
  // const index = INDEX++;
  const index = getDataIndex(context.value, options.series[0].data, interval);

  // This gives some whack results...
  // const date = new Date(context.value);

  // ...therefore, track the index of this tick:
  // options.xAxisLabelIndex = options.xAxisLabelIndex || 0;
  // options.xAxisLabelIndex %= options.series[0].data.length;
  // const index = options.xAxisLabelIndex;
  // const date = new Date(options.series[0].data[index].x);
  const date = new Date(context.value);
  // options.xAxisLabelIndex += 1;
 
  options.dateTimeLabelFormat = context.dateTimeLabelFormat;
  let labelFormat = options.dateTimeLabelFormat;
  // if (labelFormat === '%H:%M') labelFormat = '%e. %b'
  
  const dateObj = options.dates[index];
  switch (labelFormat) {
    case '%H:%M':
    case '%H:%M:%S':
      var incSecs = false;//context.dateTimeLabelFormat === '%H:%M:%S';
      options.series[0].data[index].xAxisLabel = formatHM(date, incSecs);
      return formatHM(date, incSecs);
    case '%e. %b':
      options.series[0].data[index].xAxisLabel = [
        MONTHS[date.getUTCMonth()],
        date.getUTCDate()
      ].join(' ');
      return [
        MONTHS[date.getUTCMonth()],
        date.getUTCDate()
      ].join(' ');
    case '%b \'%y':
      if (options.dates[index].yearIsProxy) {
        options.series[0].data[index].xAxisLabel =
          MONTHS[date.getUTCMonth()];
        return MONTHS[date.getUTCMonth()];
      } else {
        options.series[0].data[index].xAxisLabel = [
          MONTHS[date.getUTCMonth()],
          '’' + (date.getUTCFullYear() + '').substr(2)
        ].join(' ');
        return [
          MONTHS[date.getUTCMonth()],
          '’' + (date.getUTCFullYear() + '').substr(2)
        ].join(' ');
      }
    case '%Y':
      // console.log(index, date.getUTCFullYear(), date.getFullYear(), realDate.getFullYear());
      options.series[0].data[index].xAxisLabel = date.getUTCFullYear() + '';
      //(dateObj.year || realDate.getUTCFullYear()) + '';
      // return dateObj.year || (date.getFullYear() + '');
      return date.getUTCFullYear() + ''
  }
  options.series[0].data[index].xAxisLabel = '0';
  return '0';
}

function getDataIndex(value, data, interval) {
  let index = 0;
  for (let i = 0; i < data.length; i++) {
    index = i;
    if (value < data[i].x) {
      break;
    }
  }
  return index;
}

function formatHM(date, includeSeconds) {
  let h = date.getUTCHours();
  let a = (h < 12) ? ' a.m.' : ' p.m.';
  let m = addZeroes(date.getUTCMinutes(), 2);
  let s = includeSeconds ? addZeroes(date.getUTCSeconds(), 2) : null;
  if (h === 12 && m == '00') {
    return 'noon';
  }
  if (h === 0) {
    h = 12;
  } else {
    h %= 12;
  }
  m = (m === '00') ? '' : (':' + m);
  s = includeSeconds ? (':' + s) : '';
  return [ h, m, s, a ].join('');
}


// Used as Highcharts `formatter` function (not directly).
export function formatterYAxisLabel(units, value, minDecimals, special) {
  value += '';
  const decimalUnits = assign({}, units);
  if (units.forceDecimals !== undefined) {
    decimalUnits.forceDecimals = Math.max(units.forceDecimals, minDecimals);
  }
  if (units.maxDecimals !== undefined) {
    decimalUnits.maxDecimals = Math.max(units.maxDecimals, minDecimals);
  }
  value = format.decimals(value, decimalUnits);
  value = format.commas(value, units.commas);
  if (special) {
    let neg = '';
    if (units.prefix && value.charAt(0) === '-') {
      neg = '-';
      value = value.substr(1);
    }
    value = [
      neg,
      units.prefix,
      value
    ].join('');
  }
  return value;
}


// A Highcharts `formatter` function that returns 'nQ<br/>YYYY'.
function formatterQuarterlyResults(options) {
  const rows = options.series[0].data.length;
  let quarter = undefined;
  let year = undefined;
  return function () {
    let value = '';
    const parts = this.value.split(/\s/);
    let tmpQ = parts[0] || null;
    let tmpY = parts[1] || null;
    const FY = tmpY ? (tmpY.indexOf('FY') === 0) : false;
    if (FY) {
      tmpY = tmpY.substr(2);
    }
    if (this.isFirst) {
      // Sometimes Highcharts runs through the date *twice*!
      quarter = year = undefined;
    }
    if (tmpQ && rows <= 9 && options.interactive) {
      value += tmpQ;
    }
    if (tmpY) {
      if (value !== '') {
        value += '<br>';
      }
      if (tmpY !== year) {
        if (year === undefined) {
          value += (FY ? 'FY' : '') + tmpY;
        } else {
          value +=  (APOSTROPHE + tmpY.substr(2, 4));
        }
      }
    }
    quarter = tmpQ;
    year = tmpY;
    return value;
  };
}


// Returns an array of category objects as an array of strings for use as the
// value for `data[x|yAxis].categories`.
function getCategoryLabels(categories) {
  const strings = [];
  if (categories) {
    categories.forEach((cat, index) => {
      if (typeof cat === 'string' || typeof cat === 'number') {
        strings[index] = cat + '';
      } else if (cat && typeof cat === 'object') {
        strings[index] = cat.text;
      } else {
        strings[index] = null;
      }
    });
  }
  return strings;
}


// Attempts to allow manual tweaking of min and max axis values, but does not
// quite do what is requested: Set an *absolute* max and min, whereas
// Highcharts uses the values as a guide.
function writeMinMax(data, options) {
  if (options.type !== 'pie') {
    if (options.axes.minYAxisValue !== undefined) {
      data.yAxis.min = options.axes.minYAxisValue;
    }
    if (options.axes.maxYAxisValue !== undefined) {
      data.yAxis.max = options.axes.maxYAxisValue;
    }
  }
  return data;
}

// Finds if yAxis.min should be set automatically so as to ensure that
// a zero line is included.
function valuesBelowPositive2(options) {
  let found = false;
  for (let s = 0; s < options.series.length; s++) {
    for (let d = 0; d < options.series[s].data.length; d++) {
      if (options.series[s].data[d].y < 0) {
        return false;
      } else if (!found && options.series[s].data[d].y <= 2) {
        found = true;
      }
    }
  }
  return found;
}

// Finds if yAxis.max should be set automatically so as to ensure that
// a zero line is included.
function valuesAboveNegative2(options) {
  let found = false;
  for (let s = 0; s < options.series.length; s++) {
    for (let d = 0; d < options.series[s].data.length; d++) {
      if (options.series[s].data[d].y > 0) {
        return false;
      } else if (!found && options.series[s].data[d].y <= -2) {
        found = true;
      }
    }
  }
  return found;
}

// Sometimes decimals are 17 or something outrageous, but decimalsDelta is something like 0.20000000000000002
// which should be just 0.2. This fixes the issue.
function roundPlaces(float) {
  for (var places = 1; places < 19; places++) {
    if (float.toFixed(places) + '0' === float.toFixed(places + 1)) break; 
  }
  return places;
}


// WEBPACK FOOTER //
// ./src/chart/inner/axes-prerender.js